/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GlobalStyle } from 'styles/global-styles';
import { HomePage } from './pages/HomePage/Loadable';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import HomeLayout from './components/HomeLayout';
import { ComponentesPage } from './pages/ComponentsPage';
import { Toast } from './components/Toast';
import {
  AddFacilityPage,
  AddLoanPage,
  FacilityDetailsPage,
  FacilityPage,
  LoanListPage,
  RenewFacilityPage,
  FacilityHistoryDetails,
  RenewalHistoryPage,
  LoanDetailPage,
  AddNewUserPage,
  MasterDataPage,
  UserListPage,
  LoanHistoryDetails,
  ModifyLoanPage,
  AddSubLimitPage,
  LetterOFCreditListPage,
  CreateOrUpdateLCPage,
  NotificationPage,
  LoginPage,
  SubLoanDetailPage,
  LetterOfCreditDetailPage,
  FixedDepositPage,
  CreateOrUpdateFixedDepositPage,
  GuaranteeProgramListPage,
  AddGuaranteeProgramPage,
  GuaranteeProgramDetailPage,
  GuaranteeReportPage,
  GuaranteeReportDetailPage,
  GuaranteeSummaryListPage,
  GuaranteeSummaryDetailPage,
} from './pages/exportpages';
import { DashboardPage } from './pages/DashboardPage';
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/dashboard/facility" replace />}
        />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<HomeLayout />}>
          <Route path="/dashboard/:type" element={<DashboardPage />} />
          <Route path="/logout" element={<HomePage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/components" element={<ComponentesPage />} />
          <Route path="/facility" element={<FacilityPage />} />
          <Route path="/facility/add-facility" element={<AddFacilityPage />} />
          <Route
            path="/facility/facility-details/:facilityId"
            element={<FacilityDetailsPage />}
          />
          <Route
            path="/facility/renew-facility/:facilityId"
            element={<RenewFacilityPage />}
          />
          <Route
            path="/facility/facility-details/:type/:facilityId"
            element={<AddSubLimitPage />}
          />
          <Route
            path="/facility/facility-details/renewal-history/:facilityId"
            element={<RenewalHistoryPage />}
          />
          <Route path="/loan" element={<LoanListPage />} />
          <Route
            path="/facility/facility-details/history-details"
            element={<FacilityHistoryDetails />}
          />
          <Route path="/loan/add" element={<AddLoanPage />} />
          <Route
            path="/loan/loan-details/history-details"
            element={<LoanHistoryDetails />}
          />
          <Route
            path="/loan/loan-details/:loanId"
            element={<LoanDetailPage />}
          />
          <Route path="/user/add-user" element={<AddNewUserPage />} />
          <Route
            path="/loan/loan-details/modify/:loanId"
            element={<ModifyLoanPage />}
          />
          <Route path="/master-data" element={<MasterDataPage />} />
          <Route path="/user" element={<UserListPage />} />
          <Route
            path="/letter-of-credit/:type"
            element={<CreateOrUpdateLCPage />}
          />
          <Route
            path="/letter-of-credit/:type/:letterOfCreditId"
            element={<CreateOrUpdateLCPage />}
          />
          <Route
            path="/letter-of-credit/letter-of-credit-details/:type/:letterOfCreditId"
            element={<CreateOrUpdateLCPage />}
          />
          <Route
            path="/letter-of-credit"
            element={<LetterOFCreditListPage />}
          />
          <Route
            path="/letter-of-credit/letter-of-credit-details/:letterOfCreditId"
            element={<LetterOfCreditDetailPage />}
          />
          <Route
            path="/letter-of-credit/convert/:letterOfCreditType/:letterOfCreditId"
            element={<AddLoanPage />}
          />
          <Route
            path="/letter-of-credit/letter-of-credit-details/convert/:letterOfCreditType/:letterOfCreditId"
            element={<AddLoanPage />}
          />
          <Route path="/notification" element={<NotificationPage />} />
          <Route
            path="/loan/loan-details/sub-loan-details/:subLoanId"
            element={<SubLoanDetailPage />}
          />
          <Route path="/fixed-deposit" element={<FixedDepositPage />} />
          <Route
            path="/guarantee-program"
            element={<GuaranteeProgramListPage />}
          />
          <Route
            path="/guarantee-program/add"
            element={<AddGuaranteeProgramPage />}
          />
          <Route
            path="/guarantee-program/guarantee-details/modify/:guaranteeProgramId"
            element={<AddGuaranteeProgramPage />}
          />
          <Route
            path="/guarantee-program/guarantee-details/:guaranteeProgramId"
            element={<GuaranteeProgramDetailPage />}
          />
          <Route path="/guarantee-summary" element={<GuaranteeSummaryListPage />} />
          <Route path="/guarantee-report" element={<GuaranteeReportPage />} />
          <Route
            path="/guarantee-report/guarantee-report-details/:reportId"
            element={<GuaranteeReportDetailPage />}
          />
          <Route
            path="/guarantee-report/guarantee-summary-details/:filterBy/:filterValue"
            element={<GuaranteeSummaryDetailPage />}
          />
          <Route
            path="/fixed-deposit/:type"
            element={<CreateOrUpdateFixedDepositPage />}
          />
          <Route
            path="/fixed-deposit/:type/:fixedDepositId"
            element={<CreateOrUpdateFixedDepositPage />}
          />
        </Route>
      </Routes>
      <GlobalStyle />
      <Toast />
    </BrowserRouter>
  );
}
